import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['singleForm', 'multipleForm']

  connect() {
    const checkedRadio = this.element.querySelector('input[name="legal_profile[has_multiple_beneficiaries]"]:checked')
    if (checkedRadio) {
      this.applyChoice(checkedRadio.value === 'true')
    }
  }

  toggleChoice(event) {
    this.applyChoice(event.target.value === 'true')
  }

  applyChoice(hasMultiple) {
    if (hasMultiple) {
      this.singleFormTarget.classList.add('d-none')
      this.multipleFormTarget.classList.remove('d-none')
      this.disableInputs(this.singleFormTarget)
      this.enableInputs(this.multipleFormTarget)
    } else {
      this.singleFormTarget.classList.remove('d-none')
      this.multipleFormTarget.classList.add('d-none')
      this.enableInputs(this.singleFormTarget)
      this.disableInputs(this.multipleFormTarget)
    }
  }

  disableInputs(container) {
    const inputs = container.querySelectorAll('input, select, textarea')
    inputs.forEach(input => {
      input.disabled = true

      if (input.tomselect) {
        input.tomselect.disable()
      }
    })
  }

  enableInputs(container) {
    const inputs = container.querySelectorAll('input, select, textarea')
    inputs.forEach(input => {
      input.disabled = false

      if (input.tomselect) {
        input.tomselect.enable()
      }
    })
  }
}
